import { useContext } from 'react';
import { ResourceDefinitionContext } from './ResourceDefinitionContext';
export var useResourceDefinitionContext = function () {
    return useContext(ResourceDefinitionContext);
};
//# sourceMappingURL=useResourceDefinitionContext.js.map